import { render } from "./SignatureNodeView.vue?vue&type=template&id=526b4ced&scoped=true"
import script from "./SignatureNodeView.vue?vue&type=script&lang=js"
export * from "./SignatureNodeView.vue?vue&type=script&lang=js"

import "./SignatureNodeView.vue?vue&type=style&index=0&id=526b4ced&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526b4ced"]])

export default __exports__